import getNextConfig from '@maxpreps/shared/constants/getNextConfig';
import Head from 'next/head';
import Script from 'next/script';
import { useBidBarrel } from '../../redux/bidbarrel/bidBarrelHooks';
import { AdBlockerManager } from './AdBlockManager';

const { appEnv } = getNextConfig().publicRuntimeConfig;

// The values exposted in the config here ('auction','initialize','on','destroySlots','setConfig') should match the values defined in the bidBarrelHooks.tsx interface
export const BID_BARREL_INIT_SCRIPT = `(function(a,d){
  var w=window,b='BidBarrel',q='queue';w[b]=w[b]?w[b]:{};w[b][q]=w[b][q]?w[b][q]:[];
  a.forEach(function(z){w[b][z]=function(){var c=arguments;w[b][q].push(function(r){w[b][z].apply(w[b],c);r()})}});
  if(d){var p=document,t='script',f=p.getElementsByTagName(t)[0];s=p.createElement(t);s.async=!0;s.id=b.toLowerCase();s.src=d;if(!f)f=p.head;f.parentNode.insertBefore(s,f)};
})(['auction','initialize','on','destroySlots','setConfig'],null);`;

export const BID_BARREL_SRC = `https://at.cbsi.com/lib/dist/${
  appEnv && appEnv.indexOf('production') === -1 ? 'develop' : 'prod'
}/bidbarrel-maxpreps.min.js?adaptive=true`;

// Ryan's old comment:
// i think there is a bug in next when loading external js scripts where it will execute the code twice.
// really annoying but not finding a ton (found some) of supporting material online
// closest thing i could find to being a lead - https://github.com/vercel/next.js/issues/9070
// possible work around - https://github.com/vercel/next.js/issues/5697
export const BidBarrel = ({
  projectConfig,
  pageConfig,
  deviceType,
  appType,
  pageViewGuid,
  contextDataPoints
}) => {
  useBidBarrel({
    projectConfig,
    pageConfig,
    deviceType,
    appType,
    pageViewGuid,
    contextDataPoints
  });

  return (
    <>
      <Head>
        {/* Actual BB Script include/setup */}
        <script
          key="bb-init-script"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: BID_BARREL_INIT_SCRIPT
          }}
        />
      </Head>
      <Script
        id="bb-release-script"
        src={BID_BARREL_SRC}
        strategy="lazyOnload"
      />
      <AdBlockerManager />
    </>
  );
};
